export const splitArrayIntoTwoHalves = <T>(array: T[]) => {
  const half = Math.max(array.length / 2, 2);

  const firstHalf = array.slice(0, half);
  const secondHalf = array.slice(half, array.length);

  return {
    firstHalf,
    secondHalf,
  };
};